import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-blank-page',
  templateUrl: './blank-page.component.html',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  styleUrls: ['./blank-page.component.scss']
})
export class BlankPageComponent implements OnInit, OnDestroy {
  isLoading = false;
  loaderSubscription: Subscription | undefined;
  constructor(private authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
    this.loaderSubscription = this.authService.loaderVal$.subscribe(loading => {
      this.isLoading = loading;
        });

    // Safety check: Prevent continuous browser reloading loops
    if (sessionStorage.getItem('logout_loop_breaker')) {
      sessionStorage.removeItem('logout_loop_breaker');
      window.location.href = '/login?returnUrl=%2F'; // Hard redirect to break SPA loops
      return;
    }
    sessionStorage.setItem('logout_loop_breaker', 'true');

    // Update URL immediately so if logout() triggers a reload, it lands safely on the login page
    window.history.replaceState(null, '', '/login?returnUrl=%2F');

    this.authService.logout();

    setTimeout(() => {
      this.router.navigate(['/login'], { queryParams: { returnUrl: '/' } }).then(() => {
        sessionStorage.removeItem('logout_loop_breaker');
      });
    }, 800);
  }

  ngOnDestroy(): void {
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
  }

}
